import {Component, Input} from '@angular/core';
import {
  InsparkScheduleTamplateModule
} from '../../../../projects/common/modules/schedule-tamplate/schedule-tamplate.module';
import {InsparkTabPanelModule} from '../../../../projects/common/modules/inspark-tab-panel/inspark-tab-panel.module';
import {CommonModule, NgIf} from '@angular/common';
import {ParamonApiService} from '../../../../projects/api/src/paramon/paramon-api.service';
import {TimerangesApiService} from '../../../../projects/api/src/timerange/timeranges-api.service';
import {ParamonModel} from '../../../../projects/api/src/paramon/paramon.model';
import {TimerangeModel} from '../../../../projects/api/src/timerange/timerange.model';
import {SpinnerComponent} from '../../shared/spinner/spinner.component';
import {TimerangeApiService} from '../../../../projects/api/src/timerange/timerange-api.service';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-timerange-panel',
  templateUrl: './timerange-panel.component.html',
  styleUrls: ['./timerange-panel.component.scss'],
  imports: [
    CommonModule,
    InsparkScheduleTamplateModule,
    InsparkTabPanelModule,
    NgIf,
    SpinnerComponent
  ],
  providers: [
    ParamonApiService,
    TimerangesApiService,
    TimerangeApiService,
    TranslateService
  ],
  standalone: true
})
export class TimerangePanelComponent {
  @Input() editableData: ParamonModel;
  @Input() timeranges: TimerangeModel[] = [];

  constructor(
    public config: DynamicDialogConfig,
  ) {
  }

  updateOnOrOff(data: any, timeranges: TimerangeModel[]): void {
    const timerange = timeranges.find(tr => tr.timeRange.id === data.timeranges.id);

    if (timerange) {
      timerange.valueOff = data.timeranges.offvalue;
      timerange.valueOn = data.timeranges.onvalue;
    } else {
      this.timeranges.push({
        paramOn: this.editableData,
        timeRange: data.timeranges,
        valueOff: data.timeranges.offvalue,
        valueOn: data.timeranges.onvalue
      });
    }
  }
}

